import {Node} from "../../../model/Graph";
import {names} from "../node/names";
import {getVoMetadata, ValueObjectMetadata} from "./get-vo-metadata";
import {isStateVo} from "./is-state-vo";
import {isListVo} from "./is-list-vo";

export const getSchemaRefName = (vo: Node, voMeta: ValueObjectMetadata, asPropertyRef?: boolean, asFormRef?: boolean): string => {
  const ns = voMeta.ns || '/';
  const voClassName = names(vo.getTechnicalName()).className;

  const propRef = isStateVo(vo) && asPropertyRef ? ':' + voMeta.identifier : '';

  const formRef = asFormRef ? '/Form' : '';

  return ns + (ns[ns.length - 1] === "/" ? voClassName : '/' + voClassName) + formRef + propRef;
}
